import React, { useEffect } from 'react';
import AirfieldInfo from '../components/AirfieldInfo';

const AirfieldInfoPage: React.FC = () => {
  useEffect(() => {
    // Cleanup function to remove scripts and global variables
    const cleanup = () => {
      // Remove any existing METAR scripts
      const scripts = document.querySelectorAll('script[src*="metar-taf.com"]');
      scripts.forEach(script => script.remove());

      // Clean up any global variables
      const globalObj = window as any;
      Object.keys(globalObj).forEach(key => {
        if (key.startsWith('mt')) {
          delete globalObj[key];
        }
      });
    };

    // Initial cleanup
    cleanup();

    // Cleanup on unmount
    return cleanup;
  }, []);

  return (
    <>
      <AirfieldInfo />
    </>
  );
};

export default AirfieldInfoPage; 